import LanguageSelector from '@design/objects/language-selector/twig/assets/index'

export default function (element: HTMLElement): () => void {
  const languageSelectorEl = element.querySelector<HTMLDetailsElement>('.o-language-selector')

  if (!languageSelectorEl) {
    return () => undefined
  }

  return LanguageSelector(languageSelectorEl)
}
